import { Schema } from 'effect';

// The email shape Zod's `z.email()` checks, so addresses stored by Zod code keep decoding.
const EMAIL =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/u;

/** An email address, checked exactly and never rewritten. */
export const EmailAddress = Schema.String.check(
  Schema.isPattern(EMAIL, { expected: 'an email address' }),
).annotate({ identifier: 'EmailAddress' });
export type EmailAddress = typeof EmailAddress.Type;
